var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.896478 0C0.40117 0 0 0.403043 0 0.899928C0 1.39683 0.401498 1.79985 0.896478 1.79985H16.138C16.6333 1.79985 17.0345 1.39681 17.0345 0.899928C17.0345 0.402714 16.633 0 16.138 0H0.896478ZM0.896478 8.10007C0.40117 8.10007 0 8.50311 0 9C0 9.49688 0.401498 9.89993 0.896478 9.89993H25.1035C25.5988 9.89993 26 9.49688 26 9C26 8.50279 25.5985 8.10007 25.1035 8.10007H0.896478ZM0.896478 16.2001C0.40117 16.2001 0 16.6032 0 17.1001C0 17.597 0.401498 18 0.896478 18H16.138C16.6333 18 17.0345 17.597 17.0345 17.1001C17.0345 16.6029 16.633 16.2001 16.138 16.2001H0.896478Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.bb84e8f143a1341d84bd4b6af50123d9.svg";
export { ForwardRef as ReactComponent };